(ns ui.hyperframes-templates.actions
  "The action handlers of the templates sidebar: adding a template of
   the catalog as clip and editing the variable values of a template
   clip. A template clip is a `:hyperframes` asset whose `:asset/data`
   names the template and holds the values, which the renderer passes
   to `hyperframes render --variables`."
  (:require [datascript.core :as ds]
            [ui.editor2.actions :as actions]
            [ui.editor2.common :as common]))

(defn default-variables
  [template]
  (into {}
        (map (fn [{:keys [id default]}]
               [id default]))
        (:template/variables template)))

(defn template-asset
  [template]
  {:asset/uuid (random-uuid)
   :asset/type :hyperframes
   :asset/name (:template/name template)
   :asset/width (:template/width template)
   :asset/height (:template/height template)
   :asset/duration (:template/duration-ms template)
   :asset/data {:hyperframes/template-id (:template/id template)
                :hyperframes/variables (default-variables template)}})

(defn add-template
  [state template clip-uuid]
  (let [asset (template-asset template)]
    (-> state
        (common/transact [asset])
        (actions/add-asset-as-clip {:asset-uuid (:asset/uuid asset)
                                    :clip-uuid clip-uuid}))))

(defn show-hero-frame
  "Moves the playhead into the new clip: at its first frame a template
   shows nothing yet (entrances start after t=0), so the user would see
   an empty clip."
  [state clip-uuid]
  (let [clip (ds/entity (get-in state [:editor2 :db])
                        [:clip/uuid clip-uuid])
        duration (- (:clip/end clip)
                    (:clip/start clip))]
    (assoc-in state
              [:editor2 :playhead-position]
              (+ (:clip/start clip)
                 (min 1500
                      (quot duration 3))))))

(defn add-template!
  [{:keys [store action]}]
  (let [[_ template] action
        clip-uuid (random-uuid)]
    (swap! store
           (fn [state]
             (-> state
                 (add-template template clip-uuid)
                 (show-hero-frame clip-uuid))))
    ;; The movable layer exists only after the state changed:
    (actions/select-movable-layer! clip-uuid)
    (actions/seek! @store)))

(defn coerce-value
  "Input values are strings, a number variable keeps its number type."
  [variable-type value]
  (if (= variable-type "number")
    (let [n (js/parseFloat value)]
      (if (js/isNaN n)
        value
        n))
    value))

(defn set-variable
  [state {:keys [asset-uuid variable-id variable-type value]}]
  (let [db (get-in state [:editor2 :db])
        data (:asset/data (ds/entity db [:asset/uuid asset-uuid]))]
    (common/transact state
                     [{:asset/uuid asset-uuid
                       :asset/data (assoc-in data
                                             [:hyperframes/variables variable-id]
                                             (coerce-value variable-type value))}])))

(defn set-variable!
  [{:keys [store action]}]
  (let [[_ asset-uuid variable-id variable-type value] action]
    (swap! store
           set-variable
           {:asset-uuid asset-uuid
            :variable-id variable-id
            :variable-type variable-type
            :value value})))

(def handlers
  [{:ui.action/kind :hyperframes/add-template
    :ui.action/handler add-template!}
   {:ui.action/kind :hyperframes/set-variable
    :ui.action/handler set-variable!}])
